import Types from "./Types";

const INITIAL_STATE = {
  students: [],
  isLoading: false,
  count: "",
  resetPasswordData: null,
};

export default function superadminstudents(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_SUPERADMIN_STUDENTS_SUCCESS: {
      return {
        ...state,
        students: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_SUPERADMIN_ACTIVE_STUDENTS_SUCCESS: {
      return {
        ...state,
        students: payload.data,
        count: payload.data.length,
      };
    }

    case Types.REJECT_SUPERADMIN_STUDENT_SUCCESS: {
      let data = payload.data;
      const students = state.students.items;
      let idx = 0;
      students.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      students[idx] = data;
      return {
        ...state,
        students: { ...state.students, items: students },
      };
    }
    case Types.CREATE_SUPERADMIN_STUDENT_SUCCESS: {
      const data = payload.data.data;
      let newArray = [...state.students.items, data];
      return {
        ...state,
        students: { ...state.students, items: newArray },
        count: state.count + 1,
      };
    }
    case Types.EDIT_SUPERADMIN_STUDENT_SUCCESS: {
      let data = payload.data;
      const students = state.students.items;
      let idx = 0;
      students.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      students[idx] = data;
      return {
        ...state,
        students: { ...state.students, items: students },
      };
    }

    case Types.APPROVE_SUPERADMIN_STUDENT_SUCCESS: {
      let data = payload.data;
      const students = state.students.items;
      let idx = 0;
      students.forEach((table, index) => {
        if (table.id === data.id) {
          idx = index;
          return;
        }
      });

      students[idx] = data;
      return {
        ...state,
        students: { ...state.students, items: students },
      };
    }
    case Types.SUPERADMIN_STUDENTS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    case Types.DELETE_SUPERADMIN_STUDENT_SUCCESS: {
      const students = state.students.items;
      const newStudents = students.filter((student) => student.id !== payload);
      return {
        ...state,
        students: { ...state.students, items: newStudents },
      };
    }
    case Types.RESET_STUDENT_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPasswordData: payload.data,
      };
    }
    default: {
      return state;
    }
  }
}
